module.exports = __webpack_public_path__ + "media/theme/icon__cart-8dbc885b.svg";